<template>
  <MainLogoRegister />
  <FormCard
    :image-src="workspace?.picture"
    :title="`Unirse al equipo de trabajo de ${workspace?.name}`"
    description="Esta información nos ayudará a mejorar tu experiencia y te vinculará con tu ambiente de trabajo"
  >
    <register-new-user-form :country-id="workspace?.country" />
  </FormCard>
</template>

<script>
import { defineComponent } from "vue";

import { WorkspaceEvent } from "@/app/workspace/domain/events";
import EventBus from "@/app/shared/utils/eventBus";
import { useValidateWorkspace } from "@/app/auth/composables/useValidateWorkspace";

import MainLogoRegister from "@/app/shared/components/molecules/MainLogoRegister.vue";
import RegisterNewUserForm from "@/app/register/components/forms/RegisterNewUserForm.vue";
import FormCard from "@/app/auth/components/atoms/FormCard.vue";

export default defineComponent({
  components: {
    MainLogoRegister,
    RegisterNewUserForm,
    FormCard,
  },
  created() {
    this.validateToken();
  },
  setup() {
    const workspace = useValidateWorkspace();

    return { workspace };
  },
  computed: {
    getBusiness() {
      return this.$store.getters["getNewUserInviteBusiness"];
    },
  },
  methods: {
    setPassword($event) {
      this.password = $event;
    },
    async validateToken() {
      try {
        const token = this.$route.params.token;
        await this.$store.dispatch("validateRegisterNewUserToken", token);
        EventBus.$emit(WorkspaceEvent.EMAIL);
      } catch (error) {
        const firstError = error.data.errors[0];

        if (firstError === "Token invalido") {
          this.$router.push("/token/invalid");
        } else if (firstError === "Token expired") {
          this.$router.push("/token/expired");
        } else {
          this.$router.push("/token/expired");
        }
      }
    },
  },
});
</script>

<style lang="sass" scoped>
.container
  width: 40%
  margin-top: 70px

.drawing
  margin-top: 160px
  width: 50%
  text-align: center

.text--plan
  font-size: 20px
  font-weight: 400
  margin-top: 10px

.text--score
  font-size: 20px
  font-weight: 600

.container__info
  margin-left: 120px
  width: 82%
  text-align: center

.name
  font-weight: 600
  font-size: 30px

.flex
  display: flex
  justify-content: space-around
</style>
